<template>
  <div class="footer-content">
    <div class="ft-15-s">{{ config.copyright }}</div>
    <div class="flex-content">
      <div class="ft-15" @click="toPolicy">Privacy Policy</div>
      <div class="ft-15" @click="toService">Terms of Service</div>
      <div class="ft-15 concact">Contact Us: {{ config.email }}</div>
    </div>
    <div class="ft-15 concact-phone">Contact Us: {{ config.email }}</div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config
    }
  },
  methods: {
    toPolicy() {
      window.open(config.policy, "newW");
    },
    toService() {
      window.open(config.term, "newW");
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-content{
  width: 100%;
  height: 200px;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.flex-content{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 900px;
  margin-top: 30px;
}
.concact{
  display: inline-block;
}
.concact-phone{
  display: none;
}
.ft-15{
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
}
.ft-15-s{
  font-size: 24px;
  margin-left: 60px;
}
.line{
  margin: 0 10px;
}
@media screen and (max-width: 768px) {
  .footer-content{
    flex-direction: column;
    height: 130px;
  }
  .flex-content{
    width: 50%;
    margin-top: 12px;
  }
  .concact{
    display: none;
  }
  .concact-phone{
    display: inline-block;
    margin-top: 12px;
  }
  .ft-15-s{
    margin-left: 0;
  }
}
</style>